import React, { useContext, useState, useEffect } from "react";
import PageHeader from "../common/PageHeader/index";

import "./component-styles.scss";

import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import Loader from "../UI Component/Loader/Loader";

import AppointmentHistoryLayout from "./AppointmentHistoryLayout";
import { useHistory } from "react-router";

import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import AvatarIcon from "../../assets/Avatar.svg";
import AvatarBlue from "../../assets/AvatarBlue.svg";
import useWindowSize from "../../Hooks/useWindowSize";
import { doctorProfileFiles } from "../../Util/API Calls/APIList";
import SelectDoctorMobileView from "../Staff/CommonComponents/SelectDoctorModal/SelectDoctorMobileView";
import SelectDoctorDesktopView from "../Staff/CommonComponents/SelectDoctorModal/SelectDoctorDesktopView";
import moment from "moment";
import DoctorContext from "../ClinicComponents/ClinicWrapper/DoctorContext";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";

export default function AppointmentHistory(props) {
  const [pastAppointmentData, setPastAppointmentData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [upcomingAppointmentCount, setUpcomingAppointmentCount] = useState(0);

  // const [temp_doctor_selected, setTempDoctorSelected] = useState([]);
  const [arrayAllDoctorId, setArrayAllDoctorId] = useState([]);
  // Loader
  const [loading, setLoading] = useState(false);
  const [slugUrl, setSlugUrl] = useState();
  let is_staff = localStorage.getItem("user_type");
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  // new Logic started
  const staff_context = useContext(DoctorContext);
  const [doctorFilterList, setDoctorFilterList] = useState([
    { name: "All", value: "all" },
  ]);
  const [doctor_selected, setDoctorSelected] = useState([]);
  const [temp_doctor_selected, setTempDoctorSelected] = useState([]);
  const [ddlist, setDDlist] = useState([]);
  const maxAvatars = 2;
  const [doctorselectModal, setDoctorSelectModal] = useState(false);
  const [showMobileView, setShowMobileView] = useState(false);
  const size = useWindowSize();
  const history = useHistory();

  let pageNumber =
    history.location.state && history.location.state.pageNumber
      ? history.location.state.pageNumber
      : props?.match?.params?.pageNo
      ? +props?.match?.params?.pageNo
      : 1;
  let appointmentConsultationFilter = JSON.parse(
    localStorage.getItem("appointmentConsultationFilter")
  );
  let appointmentStatusFilter = JSON.parse(
    localStorage.getItem("appointmentStatusFilter")
  );
  let appointmentStartDate = localStorage.getItem("appointmentStartDate")
    ? moment(localStorage.getItem("appointmentStartDate")).format("YYYY-MM-DD")
    : "";

  let appointmentEndDate = localStorage.getItem("appointmentEndDate")
    ? moment(localStorage.getItem("appointmentEndDate")).format("YYYY-MM-DD")
    : "";

  let appointmentCheckInStartDate = localStorage.getItem(
    "appointmentCheckInStartDate"
  )
    ? moment(localStorage.getItem("appointmentCheckInStartDate")).format(
        "YYYY-MM-DD"
      )
    : "";

  let appointmentCheckInEndDate = localStorage.getItem(
    "appointmentCheckInEndDate"
  )
    ? moment(localStorage.getItem("appointmentCheckInEndDate")).format(
        "YYYY-MM-DD"
      )
    : "";
  let appointmentSortFilter = localStorage.getItem("appointmentSortFilter");
  let appointmentDoctorName = JSON.parse(
    localStorage.getItem("appointmentDoctorName")
  );

  let defaultPayload = {
    search_string: "",
    sort_order: appointmentSortFilter
      ? appointmentSortFilter
      : "most_recent_first",
    status_filter: "all",
    appointment_filter: appointmentStatusFilter
      ? appointmentStatusFilter.value
      : "all",
    consultation_filter:
      appointmentConsultationFilter &&
      appointmentConsultationFilter.type == "consultation"
        ? appointmentConsultationFilter.value
          ? appointmentConsultationFilter.value
          : "all"
        : "",
    page_no: pageNumber,
    doctor_id: appointmentDoctorName ? appointmentDoctorName?.id : userId,

    staff_id: staffId,
    rows_per_page: 10,
    procedure_type_filter:
      appointmentConsultationFilter &&
      appointmentConsultationFilter.type == "procedure"
        ? appointmentConsultationFilter.value
        : "",
    start_date: appointmentStartDate ? appointmentStartDate : "",
    end_date: appointmentEndDate ? appointmentEndDate : "",
    mark_check_in_end_date: appointmentCheckInEndDate
      ? appointmentCheckInEndDate
      : "",
    mark_check_in_start_date: appointmentCheckInStartDate
      ? appointmentCheckInStartDate
      : "",
  };

  useEffect(() => {
    setDDlist(staff_context.selectedDoctor);
  }, [staff_context.selectedDoctor]);

  useEffect(() => {
    let arr = [];
    staff_context.selectedDoctor.map((data) => arr.push(data.doctor_id));
    let list = [
      { name: "All", value: "all", doctor_id: arr },
      ...staff_context.selectedDoctor,
    ];

    setDoctorFilterList(list);
    setDoctorSelected(arr);
    setTempDoctorSelected(arr);
  }, [staff_context.selectedDoctor]);

  useEffect(() => {
    if (doctor_selected.length > 0 && is_staff === "staff") {
      defaultPayload["doctor_id"] =
        is_staff === "staff" ? doctor_selected : userId;
      defaultPayload["page_no"] = pageNumber;
      defaultPayload["rows_per_page"] = 10;
      fetchPastAppointmentData(defaultPayload);
    }
  }, [doctor_selected]);

  const handleModal = () => {
    if (size && size.width < 786) {
      setShowMobileView(true);
    } else {
      setDoctorSelectModal(true);
    }
  };
  function renderRemaining() {
    const remaining = ddlist.length - maxAvatars;
    let dd = "+" + remaining.toString();
    if (remaining < 1) return null;
    return (
      <Avatar
        sx={{
          bgcolor: "#17BAE0",
          border: "2px solid white",
          boxSizing: "content-box",
          cursor: "pointer",
        }}
        style={{ position: "relative", left: `${-16 * maxAvatars + 1}px` }}
        src="/static/images/avatar/1.jpg"
        alt={dd}
        // onClick={() => setDoctorSelectModal(true)}
        onClick={handleModal}
      >
        <p style={{ fontSize: "16px", margin: "0px", color: "white" }}>{dd}</p>
      </Avatar>
    );
  }

  const groupAvatar = () => {
    return (
      <>
        {ddlist.slice(0, maxAvatars).map((ed, i) => (
          <Avatar
            alt={ed.dr_first_name}
            sx={{
              bgcolor: `${ed.profile_picture_url ? "white" : "#17BAE0"}`,
              border: "2px solid white",
              boxSizing: "content-box",
              cursor: "pointer",
            }}
            src={doctorProfileFiles + ed.profile_picture_url}
            style={{ position: "relative", left: `${-16 * i}px` }}
            // onClick={() => setDoctorSelectModal(true)}
            onClick={handleModal}
          />
        ))}
        {renderRemaining()}
      </>
    );
  };

  useEffect(() => {
    //getting the data based on page number when click back button from view prescription .
    //default page number 1.
    let pageNo = pageNumber;
    if (is_staff !== "staff") {
      fetchPastAppointmentData({
        search_string: "",
        sort_order: appointmentSortFilter
          ? appointmentSortFilter
          : "most_recent_first",
        status_filter: "all",
        appointment_filter: appointmentStatusFilter
          ? appointmentStatusFilter?.value
          : "all",
        consultation_filter:
          appointmentConsultationFilter &&
          appointmentConsultationFilter.type == "consultation"
            ? appointmentConsultationFilter.value
              ? appointmentConsultationFilter.value
              : "all"
            : "",
        page_no: pageNo,
        doctor_id: appointmentDoctorName ? appointmentDoctorName?.id : userId,
        rows_per_page: 10,
        start_date: appointmentStartDate ? appointmentStartDate : "",
        end_date: appointmentEndDate ? appointmentEndDate : "",
        mark_check_in_start_date: appointmentCheckInStartDate
          ? appointmentCheckInStartDate
          : "",
        mark_check_in_end_date: appointmentCheckInEndDate
          ? appointmentCheckInEndDate
          : "",
        procedure_type_filter:
          appointmentConsultationFilter &&
          appointmentConsultationFilter.type == "procedure"
            ? appointmentConsultationFilter.value
            : "",
      });
    }
  }, []);

  // Helper methods ==>

  const getFilterDetails = (data) => {
    let consultationFilter = JSON.parse(
      localStorage.getItem("appointmentConsultationFilter")
    );
    let statusFilter = JSON.parse(
      localStorage.getItem("appointmentStatusFilter")
    );
    let status_filter = localStorage.getItem("appointment_status_filter");
    let sortingFilter = localStorage.getItem("appointmentSortFilter");
    let start_date = data.start_date ? data.start_date : "";
    let end_date = data.end_date ? data.end_date : "";
    let startDate = localStorage.getItem("appointmentStartDate")
      ? moment(localStorage.getItem("appointmentStartDate")).format(
          "YYYY-MM-DD"
        )
      : start_date;
    let endDate = localStorage.getItem("appointmentEndDate")
      ? moment(localStorage.getItem("appointmentEndDate")).format("YYYY-MM-DD")
      : end_date;

    let checkInStartDate = localStorage.getItem("appointmentCheckInStartDate")
      ? moment(localStorage.getItem("appointmentCheckInStartDate")).format(
          "YYYY-MM-DD"
        )
      : "";

    let checkInEndDate = localStorage.getItem("appointmentCheckInEndDate")
      ? moment(localStorage.getItem("appointmentCheckInEndDate")).format(
          "YYYY-MM-DD"
        )
      : "";
    let consultationVal = "all";
    if (consultationFilter && consultationFilter.type == "consultation") {
      consultationVal = consultationFilter.value
        ? consultationFilter.value
        : "all";
    }
    let prescriptionFilter = localStorage.getItem(
      "appointmentPrescriptionFilter"
    );
    return {
      search_string: data.search_string,
      sort_order: sortingFilter ? sortingFilter : "most_recent_first",
      status_filter: status_filter ? status_filter : "all",
      appointment_filter: statusFilter ? statusFilter.value : "all",
      consultation_filter: consultationVal,
      rows_per_page: 10,
      summary_card: true,
      procedure_type_filter:
        consultationFilter && consultationFilter.type == "procedure"
          ? consultationFilter.value
          : "",
      start_date: startDate,
      end_date: endDate,
      mark_check_in_start_date: checkInStartDate,
      mark_check_in_end_date: checkInEndDate,
      prescription_filter: prescriptionFilter ? prescriptionFilter : "",
    };
  };

  // <==

  //   API Call =>
  const fetchPastAppointmentData = async (data) => {
    let docName = JSON.parse(localStorage.getItem("appointmentDoctorName"));
    let filterDetails = getFilterDetails(data);
    let payload = filterDetails;
    let pageNoFromHist = props?.match?.params?.pageNo
      ? +props?.match?.params?.pageNo
      : 1;
    let pageNo =
      history.location.state && history.location.state.pageNumber
        ? history.location.state.pageNumber
        : pageNoFromHist;
    let ids = null;
    if (docName) {
      ids = Array.isArray(docName.doctor_id)
        ? docName.doctor_id
        : [docName.doctor_id];
    } else {
      ids = doctor_selected?.length > 0 ? doctor_selected : [userId];
    }
    if (is_staff === "staff") {
      payload["doctor_ids"] = ids;
      if (props?.doctor_id?.length === 0) {
        return;
      }
    } else {
      payload["doctor_id"] = userId;
      delete payload["doctor_ids"];
    }
    payload["summary_card"] = true;
    payload["page_number"] = data?.page_no ? data?.page_no : pageNo;
    payload["page_no"] = data?.page_no ? data?.page_no : pageNo;
    payload["appointment_status_filter"] = payload["appointment_filter"];
    delete payload["appointment_filter"];
    setLoading(true);
    const response = await afterLoginApiAxios.post(
      // "/doctor/get-past-appointments",
      `/${is_staff === "staff" ? "staff" : "doctor"}/my-appointments-rev2`,
      {
        ...payload,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("id_token"),
        },
      }
    );

    if (response) {
      if (response.status === 200) {
        if (response.data) {
          setPastAppointmentData(response.data.result);
          setPageCount(response.data?.total_page_count);
          history.replace(
            `/doctor/account/appointmenthistory/${
              response?.data?.current_page_no || 1
            }`
          );
          setTotalRecords(response.data?.total_rows);
          setUpcomingAppointmentCount(
            response.data?.upcoming_appointments_count
          );
        } else {
          setPastAppointmentData([]);
          // setPageCount(0);
          setTotalRecords(0);
        }
        setLoading(false);
      } else {
        // TODO: Error handling and logging
        setPastAppointmentData([]);
        setPageCount(0);
        setTotalRecords(0);
        // setLoading(false);
      }
    } else {
      // TODO: Error handling and logging
      // setLoading(false);
    }
  };

  const fetchPastAppointmentDataByModification = (term) => {
    fetchPastAppointmentData(term);
  };
  return (
    <div className="appointment-history" style={{ overflow: "hidden" }}>
      {loading ? <Loader /> : null}
      {is_staff === "staff" ? (
        <div
          className="p-3"
          style={{
            display: "flex",
            flex: "1",
            alignItems: "center",
            border: "1px solid #D6DAE5",
          }}
        >
          <div className="" style={{ flex: "1" }}>
            <PageHeader heading="My Appointments" subheading="" />
          </div>
          {groupAvatar()}
          <AvatarGroup>
            <Avatar
              className="ml-2"
              src={ddlist.length > 1 ? AvatarIcon : AvatarBlue}
              sx={{
                bgcolor: "white",
                boxSizing: "content-box",
                cursor: "pointer",
              }}
              onClick={handleModal}
            />
          </AvatarGroup>
        </div>
      ) : (
        <div className="row mx-1 mt-3 d-none d-sm-none d-lg-flex">
          <div className="col-12">
            <PageHeader heading="My Appointments" subheading="" />
          </div>
        </div>
      )}
      <AppointmentHistoryLayout
        upcomingAppointmentCount={upcomingAppointmentCount}
        onSubmit={fetchPastAppointmentDataByModification}
        pageCount={pageCount}
        pastAppointmentData={pastAppointmentData}
        fetchPastAppointmentDataList={(term) => {
          fetchPastAppointmentData(term);
        }}
        totalRecords={totalRecords}
        slugUrl={slugUrl}
        pageNo={pageNumber}
        arrayAllDoctorId={arrayAllDoctorId}
        doctor_selected={doctor_selected}
        setDoctorSelected={setDoctorSelected}
        doctorFilterList={doctorFilterList}
        setTempDoctorSelected={setTempDoctorSelected}
        temp_doctor_selected={temp_doctor_selected}
      />

      {doctorselectModal ? (
        <SelectDoctorDesktopView
          show={doctorselectModal}
          onHide={() => {
            setDoctorSelectModal(false);
          }}
        />
      ) : null}

      {showMobileView ? (
        <SelectDoctorMobileView
          show={showMobileView}
          onHide={() => setShowMobileView(false)}
        />
      ) : null}
    </div>
  );
}
